// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Relations/AddRelation/Search/Content/Profiles/Content/Profile/AddPersonRelation/Content/updatePersonRelationshipsMutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Profile_Content_Relations_AddRelation_Search_Content_Profiles_Content_Profile_AddPersonRelation_Content($relationships: json) {
  update_person_relationships(
    args: { _relationships: $relationships, add_contact_method_to_self: false }
  ) {
    id
  }
}

`